import { render, staticRenderFns } from "./TaskSettings.vue?vue&type=template&id=5e2ce9d6&scoped=true&"
import script from "./TaskSettings.vue?vue&type=script&lang=js&"
export * from "./TaskSettings.vue?vue&type=script&lang=js&"
import style0 from "./TaskSettings.vue?vue&type=style&index=0&id=5e2ce9d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ce9d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2ce9d6')) {
      api.createRecord('5e2ce9d6', component.options)
    } else {
      api.reload('5e2ce9d6', component.options)
    }
    module.hot.accept("./TaskSettings.vue?vue&type=template&id=5e2ce9d6&scoped=true&", function () {
      api.rerender('5e2ce9d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/TaskSettings.vue"
export default component.exports